import { render } from "./CguView.vue?vue&type=template&id=2d1b05b6"
import script from "./CguView.vue?vue&type=script&lang=js"
export * from "./CguView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__